module.exports = __webpack_public_path__ + "img/abgc5.25313087.jpg";